function cleanObject<T>(obj: T) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null && v !== ""));
}

export default cleanObject;
